import React from 'react';
import {useTranslation} from 'react-i18next';
import AccountControlPanel from '../AccountControlPanel/AccountControlPanel';
import Header from '../../components/ListViewHeader/Header';
import AccountDashboardCallActivityWidget from './Widgets/AccountDashboardCallActivityWidget';
import {useStyles} from './AccountDashboard.utils';
import AccountDashboardRingGroupsWidget from './Widgets/AccountDashboardRingGroupsWidget';
import AccountDashboardCallForwardingWidget from './Widgets/AccountDashboardCallForwardingWidget';
import AccountDashboardPlanWidget from './Widgets/AccountDashboardPlanWidget';
import usePageTitle from '../../hooks/usePageTitle';
import PermissionProvider from '../../components/PermissionProvider/PermissionProvider';
import { AccountPermission, PermissionType } from '../../store/types/Permission';
import { usePermissions } from '../../hooks/usePermissions';
import AccessDenied from '../../components/PermissionProvider/AccessDenied';

const AccountDashboard = () => {
    const classes = useStyles();
    const {t} = useTranslation();
    usePageTitle();

    const permission = usePermissions(...AccountPermission.Dashboard.value);
    const callActivityPermission = usePermissions(...AccountPermission.Dashboard.CallActivity.value);

    if(permission == PermissionType.Hidden) {
        return <AccessDenied />;
    }

    return (
        <PermissionProvider permission={AccountPermission.Dashboard.value} >
            <div className={classes.mainDashboardContainer}>
                <div className={classes.header}>
                    <Header title={t('screens:dashboard.dashboard')} hideTotal/>
                    <div className={classes.rightSection}>
                        <AccountControlPanel />
                    </div>
                </div>
                <div className={classes.dashboardContentContainer}>

                    <div className={classes.dashboardLeftPart}>
                    <AccountDashboardCallActivityWidget />
                    </div>

                    <div className={classes.dashboardRightPart} style={{
                        marginLeft: callActivityPermission == PermissionType.Hidden ? 0 : 24
                    }} >
                        <AccountDashboardRingGroupsWidget />

                        <AccountDashboardCallForwardingWidget />

                        <AccountDashboardPlanWidget />
                    </div>
                </div>
                
            </div>
        </PermissionProvider>
    );
};

export default AccountDashboard;
